import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface ModalHeaderProps {
  onClose: () => void;
  onClearChat: () => void;
  showClear: boolean;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose, onClearChat, showClear }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2, borderBottom: '1px solid #e5e7eb' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ width: 32, height: 32, bgcolor: 'black', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AutoAwesomeIcon sx={{ fontSize: 20, color: 'white' }} />
      </Box>
      <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#111827' }}>AI Assistant</Typography>
      <Box sx={{ bgcolor: '#3b82f6', color: 'white', fontSize: '10px', fontWeight: 700, px: 1, py: 0.5, borderRadius: '4px' }}>BETA</Box>
    </Box>
    <Box sx={{ display: 'flex', gap: 1 }}>
      {showClear && (
        <Tooltip title="Clear chat" placement="top-end">
          <IconButton onClick={onClearChat} sx={{ color: '#9ca3af', '&:hover': { color: '#4b5563' } }}>
            <DeleteOutlineIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Close" placement="top-end">
        <IconButton onClick={onClose} sx={{ color: '#9ca3af', '&:hover': { color: '#4b5563' } }}>
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
    </Box>
  </Box>
);
